<nav class="document-pagination" aria-label="Pagination des documents">
  <div class="document-pagination__nav-slot document-pagination__nav-slot--prev">
    @if (canGoPrevious()) {
      <button
        type="button"
        class="document-pagination__control document-pagination__control--nav"
        aria-label="Page précédente"
        (click)="goPrevious()"
      >
        <img
          class="document-pagination__arrow"
          src="assets/img/icon-arrow-back-slider.svg"
          alt=""
          width="24"
          height="24"
        />
      </button>
    }
  </div>

  <div class="document-pagination__pages">
    @for (page of pages(); track page) {
      <button
        type="button"
        class="document-pagination__control document-pagination__control--page"
        [class.document-pagination__control--current]="page === currentPage()"
        [attr.aria-current]="page === currentPage() ? 'page' : null"
        [attr.aria-label]="'Page ' + page"
        (click)="goToPage(page)"
      >
        {{ page }}
      </button>
    }
  </div>

  <div class="document-pagination__nav-slot document-pagination__nav-slot--next">
    @if (canGoNext()) {
      <button
        type="button"
        class="document-pagination__control document-pagination__control--nav"
        aria-label="Page suivante"
        (click)="goNext()"
      >
        <img
          class="document-pagination__arrow document-pagination__arrow--forward"
          src="assets/img/icon-arrow-back-slider.svg"
          alt=""
          width="24"
          height="24"
        />
      </button>
    }
  </div>
</nav>
